/**
 * The email address of the support team.
 */
export const SUPPORT_EMAIL = 'support@stratumn.com' as const;
